import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spinner from '../../../../../../components/Spinner/index';
import { formInputValidation } from '../../../../../../services/helper/form-helper';
import {
    fetchCountries,
    fetchStates
} from '../../../../../../services/redux/commonData/actions';
import {
    editClient,
    updateEditClientPayload
} from '../../../../../../services/redux/employee/clientInformation/actions';
import EditClientForm from "../../components/ClientForm";
import Panel from "../../../../../../components/angle/Panel";

class EditClient extends Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.onSaveClick = this.onSaveClick.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
    }
    componentDidMount() {
        let { fetchCountries, fetchStates } = this.props;
        fetchCountries();
        fetchStates();
    }
    onSaveClick() {
        let { clientInformation, history, editClient } = this.props;
        let payload = clientInformation.editClientData;
        if (formInputValidation(this.formRef.current)) {
            editClient(payload).then(response => {
                if (response.status === 200) {
                    history.push('/client-information');
                }
            });
        }
    }

    onCancelClick() {
        let { history } = this.props;
        history.push('/client-information');
    }

    render() {
        let {
            clientInformation,
            commonData,
            updateEditClientPayload
        } = this.props;

        let saveButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onSaveClick}
            >
                Save
            </button>
        );

        let cancelButton = (
            <button
                type="button"
                className="btn btn-default btn-bordered"
                onClick={this.onCancelClick}
            >
                Cancel
            </button>
        );

        const buttonList = [saveButton, cancelButton];

        return (
            <div className="col-md-6 mb" style={{padding: 0}}>
                <Panel
                    showHeader
                    header="Edit Client"
                    showFooter
                    footerComponents={buttonList}
                >
                    <div>
                        <EditClientForm
                            clientData={clientInformation.editClientData}
                            countryList={commonData.countries}
                            stateList={commonData.states}
                            updateClientData={updateEditClientPayload}
                            formRef={this.formRef}
                        />
                    </div>
                </Panel>

                {clientInformation.fetching && <Spinner />}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    clientInformation: state.employee.clientInformation,
    commonData: state.commonData
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchCountries,
            fetchStates,
            editClient,
            updateEditClientPayload
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(EditClient));



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/ClientInformation/screens/EditClient/index.js